import { Link } from '@tanstack/react-router'
import { AlertTriangle, FileQuestion, Loader2 } from 'lucide-react'
import { Button } from '@/components/ui/button'

/**
 * Estados globais de rota. Cobrem o que no Next.js eram os arquivos de
 * convenção `loading.tsx`, `error.tsx` e `not-found.tsx` — que este projeto
 * nunca chegou a ter, então cada página resolvia por conta própria.
 */

export function RoutePending() {
  return (
    <div className="flex items-center justify-center py-20" style={{ color: '#6B6A64' }}>
      <Loader2 className="w-5 h-5 animate-spin mr-2" />
      <span className="text-sm">Carregando…</span>
    </div>
  )
}

export function RouteError({ error }: { error: Error }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <div
        className="w-12 h-12 rounded-xl flex items-center justify-center mb-4"
        style={{ background: '#FFF1F2' }}
      >
        <AlertTriangle className="w-6 h-6" style={{ color: '#BE123C' }} />
      </div>
      <h2 className="text-lg font-semibold" style={{ color: '#1A1A1A' }}>
        Algo deu errado
      </h2>
      <p className="mt-1 text-sm max-w-md" style={{ color: '#6B6A64' }}>
        {error?.message || 'Erro inesperado ao carregar esta página.'}
      </p>
      <Button variant="outline" size="sm" className="mt-4" onClick={() => window.location.reload()}>
        Recarregar
      </Button>
    </div>
  )
}

export function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <div
        className="w-12 h-12 rounded-xl flex items-center justify-center mb-4"
        style={{ background: '#F7F3EA' }}
      >
        <FileQuestion className="w-6 h-6" style={{ color: '#9A7D43' }} />
      </div>
      <h2 className="text-lg font-semibold" style={{ color: '#1A1A1A' }}>
        Página não encontrada
      </h2>
      <p className="mt-1 text-sm" style={{ color: '#6B6A64' }}>
        A rota acessada não existe neste sistema.
      </p>
      <Button variant="outline" size="sm" className="mt-4" asChild>
        <Link to="/dashboard">Voltar ao dashboard</Link>
      </Button>
    </div>
  )
}
